import { ref as l, toRefs as w, computed as u, watch as b, provide as R, resolveComponent as B, openBlock as c, createElementBlock as S, Fragment as h, renderSlot as T, normalizeProps as V, guardReactiveProps as $, createTextVNode as x, createBlock as D, Teleport as A, mergeProps as E, withCtx as P, createVNode as j, toDisplayString as z, createCommentVNode as F } from "vue";
import { useEventListener as d } from "./design-system.es125.js";
/* empty css                    */
import I from "./design-system.es128.js";
import L from "./design-system.es37.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import q from "./design-system.es69.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { usePopper as G } from "./design-system.es119.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import H from "./design-system.es296.js";
const J = {
  name: "DsTooltipNext",
  components: {
    DsBox: L,
    DsMenuContainer: q
  },
  inheritAttrs: !1,
  props: {
    /**
     * Boolean to be able to control the tooltip from outside of the component.  Passing a value for this prop will make the tooltip controlled.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Content of the tooltip.  Alternatively you can use the content slot.
     */
    content: {
      type: String,
      default: null
    },
    /**
     * Position of the tooltip relative to its reference.
     */
    position: {
      type: String,
      default: "bottom",
      options: ["top", "right", "bottom", "left"]
    },
    /**
     * Boolean to be able to disable a tooltip from being able to open.
     */
    disabled: Boolean,
    /**
     * Delay in ms before the tooltip opens.  Boolean true will default to 300ms.
     */
    delay: {
      type: [Number, Boolean],
      default: !0
    },
    /**
     * Reference to the trigger element.  This is used for advanced cases where the trigger ref may be used for more than just the trigger.
     */
    triggerRef: {
      type: Object,
      default: null
    }
  },
  emits: ["close"],
  setup(e, { attrs: a }) {
    const i = l(`tooltip-${H()}`), t = l(!1), o = l(null), r = l(null), s = l(null), { position: m, disabled: C, triggerRef: O } = w(e), f = u(() => e.isOpen === !0 || e.isOpen === !1);
    function p(n) {
      r.value = n;
    }
    function N() {
      t.value = !1;
    }
    function v() {
      t.value = !0;
    }
    function k() {
      if (!f.value) {
        if (!e.delay)
          v();
        else if (!o.value) {
          const n = e.delay === !0 ? 300 : e.delay;
          o.value = setTimeout(() => {
            v(), clearTimeout(o.value), o.value = null;
          }, n);
        }
      }
    }
    function g() {
      f.value || (clearTimeout(o.value), o.value = null, N());
    }
    G({
      trigger: r,
      menu: s,
      isOpen: t,
      position: m,
      disabled: C,
      arrow: !0
    }), d(r, "mouseover", k), d(r, "mouseleave", g), d(r, "click", g);
    const y = u(() => ({
      ref: e.trigger ? void 0 : p,
      "aria-describedby": i.value
    })), _ = u(() => ({
      ...y.value,
      attrs: y.value
    })), M = u(() => ({
      ...a,
      id: i.value,
      isOpen: t.value && !e.disabled,
      role: "tooltip"
    }));
    return b(O, p, { immediate: !0 }), b(
      () => e.isOpen,
      (n) => {
        t.value = n;
      },
      { immediate: !0 }
    ), R("dsTooltip", {
      registerTrigger: p,
      triggerProps: _
    }), {
      triggerProps: _,
      menuProps: M,
      menu: s
    };
  }
};
function K(e, a, i, t, o, r) {
  const s = B("DsBox"), m = B("DsMenuContainer");
  return c(), S(h, null, [
    T(e.$slots, "default", V($(t.triggerProps)), void 0, !0),
    a[0] || (a[0] = x()),
    (c(), D(A, { to: "body" }, [
      i.disabled ? F("", !0) : (c(), D(m, E({ key: 0 }, t.menuProps, {
        ref: "menu",
        arrow: "",
        class: "ds-tooltip"
      }), {
        default: P(() => [
          j(s, { padding: "spacing-200" }, {
            default: P(() => [
              T(e.$slots, "content", {}, () => [
                x(z(i.content), 1)
              ], !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16))
    ]))
  ], 64);
}
const we = /* @__PURE__ */ I(J, [["render", K], ["__scopeId", "data-v-5ff632ec"]]);
export {
  we as default
};
//# sourceMappingURL=design-system.es331.js.map
